<template>
  <div class="wi-100x ht-150 pf tp-0 lf-0 z-4">
    <!-- LOGO -->
    <div v-show="isShowIcon" @click="router('/')" class="dis-ib cur-p nav-menu-icon-logo pa mg-a z-9">
      <svg v-if="showMenu" x="0px" y="0px" viewBox="0 0 307.6 306.7">
        <polygon fill="#1f1e1d" points="147.9,5.7 302.1,5.7 302.1,159.9 " />
        <circle fill="#1f1e1d" cx="70.2" cy="70.2" r="70.2" />
        <circle fill="#1f1e1d" cx="237.4" cy="236.6" r="70.2" />
        <rect fill="#1f1e1d" x="5.8" y="172.1" class="st0" width="130.3" height="130" />
      </svg>
      <svg v-else x="0px" y="0px" viewBox="0 0 307.6 306.7">
        <polygon :fill="fillColor" points="147.9,5.7 302.1,5.7 302.1,159.9 " />
        <circle :fill="fillColor" cx="70.2" cy="70.2" r="70.2" />
        <circle :fill="fillColor" cx="237.4" cy="236.6" r="70.2" />
        <rect :fill="fillColor" x="5.8" y="172.1" class="st0" width="130.3" height="130" />
      </svg>
    </div>
    <!-- 滑过提示 -->
    <div
      v-show="screenWidth>=1200"
      :class="textColor"
      class="tt-u fs-10 transition-gentle dis-ib pf bm-80 rot-90 rt-50"
      style="letter-spacing: 4px;">
      <span>Scroll</span>
    </div>
    <!-- 线条动画 -->
    <div v-show="screenWidth>=1200" :class="backColor" class="scroll-hint"></div>
    <!-- 面包屑 -->
    <div
      :class="backColor"
      @click="showMenu=true"
      class="dis-ib bdr-100 menu-icon tp-0 bm-0 nav-menu-icon-box ta-c cur-p pa mg-a">
      <i :class="[iconColor,screenWidth>=768?'transition-quick menu-child1':'']" class="dis-ib nav-menu-icon-item1 ht-2 bdr-100 pa"></i>
      <i :class="[iconColor,screenWidth>=768?'transition-quick menu-child2':'']" class="dis-ib nav-menu-icon-item2 ht-2 bdr-100 pa"></i>
      <i :class="[iconColor,screenWidth>=768?'transition-quick menu-child3':'']" class="dis-ib nav-menu-icon-item3 ht-2 bdr-100 pa"></i>
    </div>
    <!-- 隐藏菜单面板 -->
    <div
      ref="menuWrapper"
      style="border-bottom-left-radius: 2000px;"
      class="wi-0 ht-0 white-bg transition-slow pf tp-0 rt-0 z-3">
      <!-- 菜单列表 -->
      <div
        v-if="showMenu"
        :style="screenWidth>768?'height:'+(screenHeight*0.7)+'px;':'height:'+(screenHeight-100)+'px;overflow: auto;'"
        class="wi-900 pf bm-0 rt-0 lf-0 mg-a">
        <span v-show="screenWidth>768" class="menu-line transition-gentle" ref="menuLine"></span>
        <el-row>
          <el-col :span="14" :xs="24">
            <div class="nav-menu-title serif fw-600">
              <div>
                <div
                  ref="menuItem1"
                  @click="menuRouter(menu1)"
                  @mouseover="screenWidth>768?onMouseOver(1):''"
                  @mouseleave="screenWidth>768?onMouseLeave(1):''"
                  :class="screenWidth>768?'menu-item pt-6':''"
                  class="dis-ib transition-gentle op-0 pr rt--100 pb-6 pt-6">
                  <span class="menu-item-index">01</span>
                  <span>
                    {{menu1.name}}
                    <div v-if="screenWidth>768" class="default-font dis-ib fs-18 lh-20 pr lf--10 bm-2">作<br>品</div>
                    <div v-else class="default-font dis-ib fs-14 pr lf--4 bm-2">
                      作品
                    </div>
                  </span>
                  <span
                    v-show="screenWidth>768"
                    style="opacity: 0.93;"
                    :class="hoverIndex!=1 && hoverStatus ? 'wi-100x' : 'wi-2'"
                    class="dis-ib ht-100 pa tp-0 transition-gentle rt-0 white-bg"></span>
                </div>
              </div>
              <div>
                <div
                  ref="menuItem2"
                  @click="menuRouter(menu2)"
                  @mouseover="screenWidth>768?onMouseOver(2):''"
                  @mouseleave="screenWidth>768?onMouseLeave(2):''"
                  :class="screenWidth>768?'menu-item':''"
                  class="pt-6 dis-ib transition-gentle op-0 pr rt--100 pb-6">
                  <span class="menu-item-index">02</span>
                  <span>
                    {{menu2.name}}
                    <div v-if="screenWidth>768" class="default-font dis-ib fs-18 lh-20 pr lf--10 bm-2">服<br>务</div>
                    <div v-else class="default-font dis-ib fs-14 lh-20 pr lf--4 bm-2">
                      服务
                    </div>
                  </span>
                  <span
                    v-show="screenWidth>768"
                    style="opacity: 0.93;"
                    :class="hoverIndex!=2 && hoverStatus ? 'wi-100x' : 'wi-2'"
                    class="dis-ib ht-100 pa tp-0 transition-gentle rt-0 white-bg"></span>
                </div>
              </div>
              <div>
                <div
                  ref="menuItem3"
                  @click="menuRouter(menu3)"
                  @mouseover="screenWidth>768?onMouseOver(3):''"
                  @mouseleave="screenWidth>768?onMouseLeave(3):''"
                  :class="screenWidth>768?'menu-item':''"
                  class="pt-6 dis-ib transition-gentle op-0 pr rt--100 pb-6">
                  <span class="menu-item-index">03</span>
                  <span>
                    {{menu3.name}}
                    <div v-if="screenWidth>768" class="default-font dis-ib fs-18 lh-20 pr lf--10 bm-2">观<br>点</div>
                    <div v-else class="default-font dis-ib fs-14 lh-20 pr lf--4 bm-2">
                      观点
                    </div>
                  </span>
                  <span
                    v-show="screenWidth>768"
                    style="opacity: 0.93;"
                    :class="hoverIndex!=3 && hoverStatus ? 'wi-100x' : 'wi-2'"
                    class="dis-ib ht-100 pa tp-0 transition-gentle rt-0 white-bg"></span>
                </div>
              </div>
              <div>
                <div
                  ref="menuItem4"
                  @click="menuRouter(menu4)"
                  @mouseover="screenWidth>768?onMouseOver(4):''"
                  @mouseleave="screenWidth>768?onMouseLeave(4):''"
                  :class="screenWidth>768?'menu-item':''"
                  class="pt-6 dis-ib transition-gentle op-0 pr rt--100 pb-6">
                  <span class="menu-item-index">04</span>
                  <span>
                    {{menu4.name}}
                    <div v-if="screenWidth>768" class="default-font dis-ib fs-18 lh-20 pr lf--10 bm-2" :class="screenWidth<=1200?'':'hover-text-more'">联<br>系</div>
                    <div v-else class="default-font dis-ib fs-14 lh-20 pr lf--4 bm-2">
                      联系
                    </div>
                  </span>
                  <span
                    v-show="screenWidth>768"
                    style="opacity: 0.93;"
                    :class="hoverIndex!=4 && hoverStatus ? 'wi-100x' : 'wi-2'"
                    class="dis-ib ht-100 pa tp-0 transition-gentle rt-0 white-bg"></span>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="10" :xs="24">
            <div class="op-0 transition-gentle pr rt--100" :class="screenWidth<=768?'pl-20 pt-20':'pt-14'" ref="contactInfo">
              <div class="wi-300" :class="screenWidth>768?'mb-50':'mb-24'" v-for="(n, idx) in contactList" :key="idx">
                <div class="fs-26 serif fw-600" :class="screenWidth>768?'mb-10':'mb-6'">{{n.position}}</div>
                <div class="lh-22 op-8 fs-14">{{n.adress}}</div>
              </div>
              <div class="nav-menu-contact mb-10">
                <div @click="sendEmail(contactList[0].email)" :class="screenWidth<=1200?'title-default-text':'hover-text'">
                  {{contactList[0].email}}</div>
              </div>
              <div class="nav-menu-contact" :class="screenWidth>768?'mb-60':'mb-40'">
                <div @click="callPhone(contactList[0].phone)" :class="screenWidth<=1200?'title-default-text':'hover-text'">
                  {{contactList[0].phone}}</div>
                <div class="dis-ib pr tp-8" @click="callPhone(contactList[0].phone)">
                  <fo-callPhoneSvg></fo-callPhoneSvg>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- 关闭按钮 -->
      <div
        v-if="showMenu"
        ref="closeMenu"
        @click="closeMenuAction"
        class="dis-ib nav-menu-icon-close close-menu op-0 black-bg white transition-slow bdr-100 menu-icon tp-0  ta-c cur-p pa mg-a">
        <span class="dis-ib wi-24 ht-24 transition-slow centerbox">
          <i class="el-icon-close nav-menu-icon-close-inner dis-ib pa tp-0 lf-0"></i>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Navmenu',
  props: [
    'pageName',
    'logoColor',
    'iconColor',
    'backColor',
    'textColor'
  ],
  computed: {
    ...mapGetters([
      'scrollTop',
      'screenHeight',
      'screenWidth',
      'contactInfo',
      'routerInfo'
    ])
  },
  data () {
    return {
      // 是否显示logo
      isShowIcon: true,
      contactList: '',
      routerList: [],
      fillColor: '',
      hoverIndex: '',
      hoverStatus: false,
      showMenu: false,
      menu1: {
        id: '2',
        name: 'Works',
        path: '/works'
      },
      menu2: {
        id: '3',
        name: 'Service',
        path: '/service'
      },
      menu3: {
        id: '4',
        name: 'Posts',
        path: '/posts'
      },
      menu4: {
        id: '5',
        name: 'Contact',
        path: '/contact'
      }
    }
  },
  mounted () {
    var url = ''
    var index = window.location.hash.replace('#', '').indexOf('/', 1)
    if (index !== -1) {
      url = window.location.hash.replace('#', '').substring(0, index) + '/detail'
    } else {
      url = window.location.hash.replace('#', '')
    }
    if (this.screenWidth <= 768) {
      switch (url) {
        case '/home':
          if (this.scrollTop > this.screenHeight) {
            this.isShowIcon = false
          } else {
            this.isShowIcon = true
          }
          break
        // 详情
        case '/works/detail':
          var worksContainer = document.getElementsByClassName('case-head-container')
          if (this.scrollTop > worksContainer) {
            this.isShowIcon = false
          } else {
            this.isShowIcon = true
          }
          break
        // 详情
        case '/posts/detail':
          var postContainer = document.getElementsByClassName('post-head-container')
          if (this.scrollTop > postContainer) {
            this.isShowIcon = false
          } else {
            this.isShowIcon = true
          }
          break
        case '/error':
          break
        // 作品, 文章, 服务, 联系
        default:
          var height = document.getElementsByClassName('page-title-item')[0].clientHeight
          if (this.scrollTop > height) {
            this.isShowIcon = false
          } else {
            this.isShowIcon = true
          }
          break
      }
    }
    // 路由
    if (this.$.g('routerInfo')) {
      this.routerList = this.$.s2o(this.$.g('routerInfo'))
      this.routerList.map(item => {
        if (item.id === '2') {
          this.menu1 = item
        } else if (item.id === '3') {
          this.menu2 = item
        } else if (item.id === '4') {
          this.menu3 = item
        } else if (item.id === '5') {
          this.menu4 = item
        }
      })
    }
    if (this.$.g('contactInfo')) {
      this.contactList = this.$.s2o(this.$.g('contactInfo'))
    }
  },
  watch: {
    scrollTop (val) {
      if (this.screenWidth <= 768) {
        var url = ''
        var index = window.location.hash.replace('#', '').indexOf('/', 1)
        if (index !== -1) {
          url = window.location.hash.replace('#', '').substring(0, index) + '/detail'
        } else {
          url = window.location.hash.replace('#', '')
        }
        if (this.screenWidth <= 768) {
          switch (url) {
            case '/home':
              if (val > this.screenHeight) {
                this.isShowIcon = false
              } else {
                this.isShowIcon = true
              }
              break
            // 详情
            case '/works/detail':
              var worksContainer = document.getElementsByClassName('case-head-container')[0].clientHeight
              if (val > worksContainer) {
                this.isShowIcon = false
              } else {
                this.isShowIcon = true
              }
              break
            // 详情
            case '/posts/detail':
              var postContainer = document.getElementsByClassName('post-head-container')[0].clientHeight
              if (val > postContainer) {
                this.isShowIcon = false
              } else {
                this.isShowIcon = true
              }
              break
            case '/error':
              break
            // 作品, 文章, 服务, 联系
            default:
              var height = document.getElementsByClassName('page-title-item')[0].clientHeight
              if (val > height) {
                this.isShowIcon = false
              } else {
                this.isShowIcon = true
              }
              break
          }
        }
      }
    },
    screenWidth (val) {
      this.showMenuCompute()
    },
    contactInfo (val) {
      if (val) {
        this.contactList = this.$.s2o(val)
        this.$.s('contactInfo', val)
      }
    },
    routerInfo (val) {
      if (val) {
        this.routerList = this.$.s2o(val)
        this.routerList.map(item => {
          if (item.id === '2') {
            this.menu1 = item
          } else if (item.id === '3') {
            this.menu2 = item
          } else if (item.id === '4') {
            this.menu3 = item
          } else if (item.id === '5') {
            this.menu4 = item
          }
        })
        this.$.s('routerInfo', val)
      }
    },
    logoColor (val) {
      if (val === 'white') {
        this.fillColor = '#ffffff'
      } else if (val === 'black') {
        this.fillColor = '#1f1e1d'
      } else {
        this.fillColor = '#f84525'
      }
    },
    showMenu (val) {
      if (val) {
        document.body.style.overflow = 'hidden'
        if (this.screenWidth > 768) {
          this.$refs.menuWrapper.style.width = 1.6 * this.screenWidth + 'px'
          this.$refs.menuWrapper.style.height = 1.6 * this.screenWidth + 'px'
        } else {
          this.$refs.menuWrapper.style.width = 3 * this.screenWidth + 'px'
          this.$refs.menuWrapper.style.height = 3 * this.screenWidth + 'px'
        }
        setTimeout(() => {
          this.$refs.closeMenu.style.opacity = 1
        }, 200)
        setTimeout(() => {
          this.$refs.menuLine.style.opacity = 1
          this.$refs.contactInfo.style.opacity = 1
          this.$refs.contactInfo.style.right = 0
          this.$refs.menuLine.style.height = (this.screenHeight / 2 + 200) + 'px'
        }, 600)
        setTimeout(() => {
          this.$refs.menuItem1.style.opacity = 1
          this.$refs.menuItem1.style.right = 0
        }, 700)
        setTimeout(() => {
          this.$refs.menuItem2.style.opacity = 1
          this.$refs.menuItem2.style.right = 0
        }, 800)
        setTimeout(() => {
          this.$refs.menuItem3.style.opacity = 1
          this.$refs.menuItem3.style.right = 0
        }, 900)
        setTimeout(() => {
          this.$refs.menuItem4.style.opacity = 1
          this.$refs.menuItem4.style.right = 0
        }, 1000)
      } else {
        document.body.style.overflow = ''
      }
    }
  },
  methods: {
    showMenuCompute () {
      if (this.showMenu) {
        document.body.style.overflow = 'hidden'
        if (this.screenWidth > 768) {
          this.$refs.menuWrapper.style.width = 1.6 * this.screenWidth + 'px'
          this.$refs.menuWrapper.style.height = 1.6 * this.screenWidth + 'px'
        } else {
          this.$refs.menuWrapper.style.width = 3 * this.screenWidth + 'px'
          this.$refs.menuWrapper.style.height = 3 * this.screenWidth + 'px'
        }
        setTimeout(() => {
          this.$refs.closeMenu.style.opacity = 1
        }, 200)
        setTimeout(() => {
          this.$refs.menuLine.style.opacity = 1
          this.$refs.contactInfo.style.opacity = 1
          this.$refs.contactInfo.style.right = 0
          this.$refs.menuLine.style.height = (this.screenHeight / 2 + 200) + 'px'
        }, 600)
        setTimeout(() => {
          this.$refs.menuItem1.style.opacity = 1
          this.$refs.menuItem1.style.right = 0
        }, 700)
        setTimeout(() => {
          this.$refs.menuItem2.style.opacity = 1
          this.$refs.menuItem2.style.right = 0
        }, 800)
        setTimeout(() => {
          this.$refs.menuItem3.style.opacity = 1
          this.$refs.menuItem3.style.right = 0
        }, 900)
        setTimeout(() => {
          this.$refs.menuItem4.style.opacity = 1
          this.$refs.menuItem4.style.right = 0
        }, 1000)
      } else {
        document.body.style.overflow = ''
      }
    },
    sendEmail (val) {
      parent.location.href = 'mailto:' + 'val' + '?subject=' + ''
    },
    // 路由跳转
    menuRouter (val) {
      if (window.location.hash.replace('#', '') === val.path) {
        this.closeMenuAction()
      } else {
        this.router(val.path)
      }
    },
    /*
    * 调用拨电话
    */
    callPhone (phoneNumber) {
      window.location.href = 'tel:' + phoneNumber
    },
    onMouseOver (val) {
      this.hoverStatus = true
      this.hoverIndex = val
    },
    onMouseLeave (val) {
      this.hoverIndex = ''
      this.hoverStatus = false
    },
    closeMenuAction () {
      this.$refs.closeMenu.style.opacity = 0
      this.$refs.menuLine.style.height = 0
      this.$refs.menuLine.style.opacity = 0
      this.$refs.menuItem1.style.opacity = 0
      this.$refs.menuItem2.style.opacity = 0
      this.$refs.menuItem3.style.opacity = 0
      this.$refs.menuItem4.style.opacity = 0
      this.$refs.contactInfo.style.opacity = 0
      this.$refs.contactInfo.style.right = '-100px'
      setTimeout(() => {
        this.$refs.menuItem1.style.right = '-150px'
      }, 400)
      setTimeout(() => {
        this.$refs.menuItem2.style.right = '-150px'
      }, 300)
      setTimeout(() => {
        this.$refs.menuItem3.style.right = '-150px'
      }, 200)
      setTimeout(() => {
        this.$refs.menuItem4.style.right = '-150px'
      }, 100)
      setTimeout(() => {
        this.$refs.menuWrapper.style.width = 0
        this.$refs.menuWrapper.style.height = 0
      }, 700)
      setTimeout(() => {
        this.showMenu = false
      }, 800)
    }
  }
}
</script>

<style>
.menu-icon:hover .menu-child1 {
  width: 22px;
}
.menu-icon:hover .menu-child2 {
  width: 14px;
}
.menu-icon:hover .menu-child3 {
  width: 24px;
}
.close-menu:hover .centerbox {
  transform: rotate(360deg);
}
.menu-line::after {
  content: 'MENU';
  display: block;
  width: 80px;
  height: 30px;
  font-size: 14px;
  letter-spacing: 6px;
  transform: rotate(90deg);
  font-weight: 500;
  position: absolute;
  top: -50px;
  left: -46px;
}
.menu-line {
  content: '';
  display: block;
  width: 1px;
  height: 0px;
  opacity: 0;
  background-color: black;
  position: absolute;
  top: 100px;
  left: -60px;
}
.menu-item:hover {
  cursor: pointer;
  transition: all .3s;
  padding-left: 40px;
}
.menu-item:hover .menu-item-index {
  opacity: 1;
  color: black;
  left: 0;
}
.menu-item-index {
  font-size: 16px;
  position: absolute;
  top: 20px;
  left: 10px;
  transition: all .3s;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  opacity: 0;
}
.scroll-hint {
  width: 1px;
  height: 60px;
  display: block;
  animation-name: hintAnime;
  animation-duration: 3s;
  animation-iteration-count: infinite;
  position: fixed;
  bottom: 130px;
  right: 81px;
}
.nav-menu-icon-logo {
  top: -50px;
  left: 20px;
  width: 40px;
  height: 40px;
  bottom: 0px;
}
@keyframes hintAnime {
  0% {
    height: 0px;
  }
  80% {
    height: 60px;
  }
  100% {
    height: 0px;
  }
}
.nav-menu-icon-box {
  right: 20px;
  top: -50px;
  width: 40px;
  height: 40px;
}
.nav-menu-icon-item1 {
  width: 10px;
  top: 13px;
  right: 12px;
}
.nav-menu-icon-item2 {
  width: 18px;
  top: 20px;
  right: 12px;
}
.nav-menu-icon-item3 {
  width: 14px;
  top: 27px;
  right: 12px;
}
.nav-menu-icon-close {
  width: 40px;
  height: 40px;
  top: 30px;
  right: 25px;
  line-height: 40px;
}
.nav-menu-icon-close-inner {
  width: 20px;
  height: 20px;
  font-size: 20px;
  top: 2px;
  left: 2px;
}
.nav-menu-title {
  font-size: 2.5em;
  margin-left: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
  /* margin-bottom: 20px; */
}
.nav-menu-contact {
  font-size: 18px;
}
/* 大于768尺寸 */
@media screen and (min-width: 768px) {
  .nav-menu-icon-logo {
    left: 60px;
    width: 50px;
    height: 50px;
    bottom: 0px;
    top: 0px;
  }
  .nav-menu-contact {
    font-size: 22px;
  }
  .nav-menu-icon-box {
    width: 50px;
    height: 50px;
    right: 60px;
    top: 0px;
  }
  .nav-menu-icon-item1 {
    width: 14px;
    top: 16px;
    right: 14px;
  }
  .nav-menu-icon-item2 {
    width: 22px;
    top: 24px;
    right: 14px;
  }
  .nav-menu-icon-item3 {
    width: 18px;
    top: 32px;
    right: 14px;
  }
  .nav-menu-icon-close {
    width: 50px;
    height: 50px;
    top: 50px;
    line-height: 50px;
    right: 60px;
  }
  .nav-menu-icon-close-inner {
    width: 22px;
    height: 22px;
    font-size: 22px;
  }
  .nav-menu-title {
    font-size: 80px;
  }
}
</style>



// WEBPACK FOOTER //
// src/compos/Navmenu.vue